module.exports = __webpack_public_path__ + "img/health21_7-9-2021.71a8a06a.jpg";